import { isDefined } from "@clipboard-health/util-ts";

import { type PlacementWithDetails } from "../../../api/useFetchPaginatedPlacements";
import { usePayTransparencyRates } from "../../../lib/usePayTransparencyRates";
import { type TransparencyPayRate } from "../../../types/payRate";

export function usePayTransparency(placement?: PlacementWithDetails) {
  const { getPayRatesForPlacement, isLoading: payDataIsLoading } = usePayTransparencyRates();

  if (!isDefined(placement)) {
    return {
      isPayTransparencyAvailable: false,
      getPayRatesForPlacement,
      payDataIsLoading,
      transparencyPayRates: [] as TransparencyPayRate[],
      highestMatchingQualification: "",
    };
  }

  const { transparencyPayRates, highestMatchingQualification } = getPayRatesForPlacement({
    id: placement.id,
    workplaceId: placement.workplace.id,
    workerTypes: placement.workerTypes,
    jobShifts: placement.jobShifts,
    transparencyPayRates: placement.transparencyPayRates,
    attributes: { payRange: placement.payRange },
  });

  const showPayAndScheduleForm =
    !payDataIsLoading && isDefined(transparencyPayRates) && transparencyPayRates.length > 0;

  const isPayTransparencyAvailable =
    isDefined(transparencyPayRates) &&
    isDefined(highestMatchingQualification) &&
    showPayAndScheduleForm;

  return {
    isPayTransparencyAvailable,
    getPayRatesForPlacement,
    payDataIsLoading,
    transparencyPayRates,
    highestMatchingQualification,
  };
}
